<template>
  <div class="edit-phone">
    <div class="card">
      <div class="card-header">
        <span class="card-title">修改手机号码</span>
      </div>
      <div class="card-body">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px" v-if="step === 1">
          <!-- <el-form-item label="账号" prop="account">
            <el-input v-model="form.account" placeholder="账号" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="原手机号" prop="OldPhone">
            <el-input v-model="form.OldPhone" placeholder="原手机号" disabled></el-input>
          </el-form-item>
          <el-form-item label="绑定邮箱" prop="email">
            <el-input v-model="form.email" placeholder="绑定邮箱" disabled></el-input>
          </el-form-item>
          <el-form-item label="验证方式">
            邮箱
          </el-form-item>
          <el-form-item label="验证码" prop="emailCode">
            <el-input v-model="form.emailCode" placeholder="请输入验证码" style="width: 200px;"></el-input>
            <el-button type="warning" style="margin-left: 10px;" @click="sendCode" :disabled="codeDisabled">{{ codeText }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="nextStep">下一步</el-button>
          </el-form-item>
        </el-form>

        <el-form :model="form" :rules="rules" ref="formStep2" label-width="120px" v-if="step === 2">
          <!-- <el-form-item label="账号" prop="account">
            <el-input v-model="form.account" placeholder="账号" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="原手机号码" prop="OldPhone">
            <el-input v-model="form.OldPhone" placeholder="请输入原手机号码" disabled></el-input>
          </el-form-item>
          <el-form-item label="新手机号码" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入新手机号码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="submitForm">确认修改</el-button>
            <el-button @click="prevStep">上一步</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {emailCode,updatePhone} from '@/api/personal.js'
import { getUser } from '@/utils/auth.js'
import {getInfo} from '@/api/api';
export default {
  data() {
    return {
      step: 1,
      form: {
        // account: 'zhangsan001',
        OldPhone: '',
        phone: '',
        email:'',
        emailCode: ''
      },
      rules: {
        emailCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        OldPhone: [
          { required: true, message: '请输入原手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入新手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      codeDisabled: false,
      codeText: '获取验证码',
      countdown: 60
    }
  },
  created(){
    // 个人
    this.form.OldPhone=getUser()&&getUser().phonenumber||''
    this.form.email=getUser()&&getUser().email||''
    //企业
  },
  methods: {
    sendCode() {
      emailCode({
        type:'changePhone'
      }).then(res=>{
        if(res.data.code==200&&res.data.data){
          this.$message.success('验证码已发送至绑定邮箱')
        }
      })
      this.codeDisabled = true
      this.countdown = 60
      this.codeText = `${this.countdown}秒后重新获取`
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
          this.codeDisabled = false
          this.codeText = '获取验证码'
        } else {
          this.codeText = `${this.countdown}秒后重新获取`
        }
      }, 1000)
    },
    nextStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.step = 2
        } else {
          return false
        }
      })
    },
    prevStep() {
      this.step = 1
    },
    submitForm() {
      this.$refs.formStep2.validate((valid) => {
        if (valid) {
          updatePhone({
            OldPhone: this.form.OldPhone,
            phone: this.form.phone,
            emailCode: this.form.emailCode
          }).then(res=>{
            if(res.data.code==200&&res.data.data){
              this.$message.success('修改成功')
              this.step = 1
              this.form.OldPhone = this.form.phone
              this.form.phone = ''
              this.form.emailCode = ''
              getInfo().then(userRes => {
                if (userRes.data.code === 200) {
                  localStorage.setItem('userInfo', JSON.stringify(userRes.data.data))
                }
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-phone {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .el-form {
      max-width: 600px;
    }
  }
}
</style>
